var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.appClassObject,attrs:{"id":"app"}},[_c('ion-app',[_c('ion-tabs',{ref:"tabs",on:{"IonTabsWillChange":_vm.ionTabsWillChange},scopedSlots:_vm._u([(_vm.isLoggedIn && _vm.$store.state.showTabBar)?{key:"bottom",fn:function(){return [_c('ion-tab-bar',[_c('ion-tab-button',{attrs:{"tab":"/dashboard"}},[_c('span',{staticClass:"icon-navi_dashboard"}),_c('ion-label',[_vm._v("Home")])],1),_c('ion-tab-button',{attrs:{"tab":"/vertraege"}},[_c('span',{staticClass:"icon-navi_vertraege"}),_c('ion-label',[_vm._v("Produkte")])],1),_c('ion-tab-button',{staticClass:"-add-button",attrs:{"tab":"/aktion"},on:{"click":function($event){return _vm.presentActionSheet()}}},[_c('ion-icon',{attrs:{"name":"add"}})],1),_c('ion-tab-button',{attrs:{"tab":"/nachrichten"}},[(_vm.messageCount > 0)?_c('ion-badge',[_vm._v(_vm._s(_vm.messageCount))]):_vm._e(),_c('span',{staticClass:"icon-navi_nachrichten"}),_c('ion-label',[_vm._v("Postbox")])],1),_c('ion-tab-button',{attrs:{"tab":"/menu"}},[_c('span',{staticClass:"icon-navi_menu"}),_c('ion-label',[_vm._v("Menü")])],1)],1)]},proxy:true}:null],null,true)},[_c('ion-tab',{attrs:{"tab":"/dashboard","routes":['dashboard']}},[_c('ion-vue-router',{attrs:{"name":"dashboard","animated":false}})],1),_c('ion-tab',{attrs:{"tab":"/vertraege","routes":['vertraege']}},[_c('ion-vue-router',{attrs:{"name":"vertraege","animated":false}})],1),_c('ion-tab',{attrs:{"tab":"/nachrichten","routes":['nachrichten']}},[_c('ion-vue-router',{attrs:{"name":"nachrichten","animated":false}})],1),_c('ion-tab',{attrs:{"tab":"/menu","routes":['menu']}},[_c('ion-vue-router',{attrs:{"name":"menu","animated":false}})],1),_c('ion-tab',{attrs:{"tab":"/default","routes":[
                    'login',
                    'aktivierung',
                    'vertrag',
                    'vertragsdetails',
                    'umsaetze',
                    'einzahlung',
                    'anpassen',
                    'uebersicht',
                    'auszahlung',
                    'spontanrueckzahlung',
                    'kreditcheckliste',
                    'schadensmeldung',
                    'schadensmeldung-neu',
                    'schadensmeldung-kfz',
                    'schadensmeldung-kfz-neu',
                    'schadensmeldung-haushalt',
                    'schadensmeldung-haushalt-neu',
                    'schadensmeldung-sach',
                    'schadensmeldung-sach-neu',
                    'schadensmeldung-recht',
                    'schadensmeldung-recht-neu',
                    'schadensmeldung-krankenhaus',
                    'schadensmeldung-unfall',
                    'motive-schadensmeldung',
                    'motive-schadensmeldung-kfz',
                    'motive-schadensmeldung-haushalt',
                    'motive-schadensmeldung-sach',
                    'motive-schadensmeldung-recht',
                    'profil',
                    'einstellungen',
                    'hilfe',
                    'motiv',
                    'berater',
                    'beraterdetails',
                    'motive-beraterdetails',
                    'unwetterwarnung',
                    'fonds',
                    'services',
                    'dokbox',
                    'services-unwetterwarnung',
                    'services-unwetterwarnung-neu',
                    'biketrax',
                    'services-biketrax',
                    // 'immowert',
                    'gutschein',
                    'video-termin',
                    'video-termin-abschluss',
                    'video-meeting',
                    'protected',
                    // 'services-schmerzlinderung',
                    'my21',
                    'my21-day',
                    'me1ns',
                    'me1nzuhause',
                    'me1nzuhause-vortrag',
                    'kfz-begutachtung',
                    'sepa-lastschrift',
                    'bestfit',
                    'page-not-found' ]}},[_c('ion-vue-router',{key:_vm.$route.fullPath})],1)],1),_c('dokbox-gallery',{attrs:{"slot":"fixed"},slot:"fixed"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }